// src/store/user/reducer.js
const initialState = {
  id: 1
};

export default function userSliceReducer(state = initialState, action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}